import { render, staticRenderFns } from "./rmivdIndex.vue?vue&type=template&id=2398f57b&"
import script from "./rmivdIndex.vue?vue&type=script&lang=js&"
export * from "./rmivdIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports